// Full-document render of the toppers OfferListPage: PageSkeleton (the React
// document shell) wrapping the ``offer_list_page.html`` layout DOM around
// the existing OfferListPage body assemblies. The template rendered the
// layout inside ``.l-capped-width.u-margin-bottom--xl.u-full-width-title >
// .content``: the ``content_title.html`` partial (with
// use_pre_order_phone_number=True), then the value_props island (gated
// ``{% if self.value_props %}``), then the body island (gated
// ``{% if page.body %}``). The content-title bar is the shared ``ContentTitle``
// component with the pre-order phone resolved server-side.
import React from "react";

import { templates } from "@reactivated";

import { ContentTitle } from "../components/ContentTitle";
import { OfferListPageBody } from "../components/OfferListPageBody";
import { OfferListPageValueProps } from "../components/OfferListPageValueProps";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader / SiteFooter chain via PageSkeleton, which is typed with
// mutable reactivated props. The body templates accept Immutable props, to
// which these are assignable.
type IProps = templates.OfferListPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const { page } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                <div className="content">
                    <ContentTitle
                        title={page.title}
                        phoneHref={props.content_title_phone_href}
                        phoneDisplay={props.content_title_phone_display}
                    />

                    {/* {% if self.value_props %} = StreamValue
                        truthiness (an empty stream is falsy). */}
                    {page.value_props && page.value_props.value.length > 0 ? (
                        <OfferListPageValueProps page={page} />
                    ) : null}

                    {/* {% if page.body %} = StreamValue truthiness. */}
                    {page.body && page.body.value.length > 0 ? (
                        <OfferListPageBody page={page} />
                    ) : null}
                </div>
            </div>
        </PageSkeleton>
    );
};
